import styled from "styled-components";

export default styled.div`
    .companyName {
        padding: 0 12px 4px;
        font-size: 10px;
        color: ${(props) => props.theme.subMenuText}99;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .companySelect {
        margin-top: 5px;
    }

    .companySelect > div {
        min-width: 0;
        width: 100%;
        margin-right: 0;
        background-color: white;
        border: 1px solid ${(props) => props.theme.subMenuSeparator};

        .selected {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }

    .companyMetrics {
        padding: 6px 12px 8px;
        font-size: 14px;
        display: grid;
        grid-template-columns: minmax(0, 100px) minmax(0, 50px);
        row-gap: 4px;
        column-gap: 16px;

        .metric {
            display: flex;
            align-items: center;
            justify-content: space-between;
            white-space: nowrap;
        }

        .extendedFade {
            display: flex;
            align-items: center;
            gap: 3px;

            svg {
                display: block;
            }

            .extendedFadeIcon {
                color: ${(props) => props.theme.mainMenuBackground};
            }

            .metricLabel {
                position: relative;
                top: 1px;
            }
        }

        .metricLabel {
            color: ${(props) => props.theme.subMenuText}99;
            text-transform: uppercase;
            letter-spacing: 0.05em;
        }

        .metricValue {
            font-weight: 600;
            color: ${(props) => props.theme.subMenuText};
        }

        .metricScore {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 22px;
            height: 22px;
            border-radius: 3px;
            font-weight: 700;
            color: black;
            padding: 0 4px;

            &.score-1 {
                background-color: ${(props) => props.theme.bqmqVoteScore1};
            }
            &.score-2 {
                background-color: ${(props) => props.theme.bqmqVoteScore2};
            }
            &.score-3 {
                background-color: ${(props) => props.theme.bqmqVoteScore3};
            }
            &.score-4 {
                background-color: ${(props) => props.theme.bqmqVoteScore4};
            }
            &.score-5 {
                background-color: ${(props) => props.theme.bqmqVoteScore5};
            }
        }
    }
`;
